import React from 'react';
import PropTypes from 'prop-types';
import {Box, Chip, Paper, Typography} from '@mui/material';

/**
 * One related list, boxed.
 *
 * Four of these tile into a grid, so they have to read as one family: same header shape,
 * same body height whatever they hold. The count sits in the header rather than being left
 * for the reader to tally, and each body scrolls inside its own box so a farm with fifty
 * devices takes no more room than one with two.
 */
const RelatedCard = ({title, count, action, children}) => (
  <Paper variant='outlined' sx={{p: 2, height: '100%', display: 'flex', flexDirection: 'column'}}>
    <Box sx={{display: 'flex', alignItems: 'center', gap: 1, mb: 1}}>
      <Typography variant='overline' color='text.secondary'>{title}</Typography>
      <Chip size='small' label={count} sx={{height: 20}}/>
      <Box sx={{flex: 1}}/>
      {action}
    </Box>
    <Box sx={{flex: 1, minHeight: 0}}>
      {children}
    </Box>
  </Paper>
);

RelatedCard.propTypes = {
  title: PropTypes.string.isRequired,
  count: PropTypes.number,
  action: PropTypes.node,
  children: PropTypes.node,
};

RelatedCard.defaultProps = {count: 0, action: null, children: null};

export default RelatedCard;
